import { useState, type FormEvent } from 'react'
import { Link, Navigate, useLocation } from 'react-router-dom'
import { errorText } from '@mezha/api'
import { useLoginMutation } from '../../api/endpoints/auth'
import { fromFailure, type ApiFailure } from '../../api/baseApi'
import { useEnter } from '../../app/enter'
import { useAppSelector } from '../../app/store'
import { PlankButton } from '../../ui'
import { AuthFrame, Field, FormError } from './AuthFrame'

/** `/login`: login and password. A wrong pair keeps the login and clears the password. */
export function Login() {
  const platform = useAppSelector(s => s.session.platform)
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [signIn, { isLoading }] = useLoginMutation()
  const enter = useEnter()
  const back = (useLocation().state as { from?: string } | null)?.from
  if (platform !== 'web') return <Navigate to="/" replace />

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    if (isLoading) return
    setError(null)
    try {
      await signIn({ login: login.trim(), password }).unwrap()
      await enter(back)
    } catch (err) {
      const f = fromFailure(err as ApiFailure)
      if (f.code === 'invalid_credentials') setPassword('')
      setError(f.code === 'rate_limited' && f.details.retry_after_ms ? `${errorText(f)}: подождите ${Math.ceil(Number(f.details.retry_after_ms) / 1000)} с` : errorText(f))
    }
  }

  return (
    <AuthFrame title="Вход" sub="С возвращением на Межу">
      <form onSubmit={submit} noValidate>
        <Field id="login" label="Логин" value={login} onChange={setLogin} autoComplete="username" autoFocus />
        <Field id="password" label="Пароль" type="password" value={password} onChange={setPassword} autoComplete="current-password" />
        <FormError text={error} />
        <div className="auth__actions">
          <PlankButton gold type="submit" disabled={isLoading || !login.trim() || !password} aria-busy={isLoading || undefined}>
            {isLoading ? 'Входим…' : 'Войти'}
          </PlankButton>
        </div>
        <p className="auth__alt">Нет учётной записи? <Link to="/register">Зарегистрироваться</Link></p>
      </form>
    </AuthFrame>
  )
}
